import {config} from "../environment";
import {useAsync} from "../utils/utils";

export type PermisjonssøknadFormData = {
  plasseringId: number,
  barnIdent: string,
  periode: string,
  begrunnelse: string
}

type PermisjonssøknadRequest = {
  barnIdent: string
  plasseringId: string
  startDato: string
  sluttDato: string
  begrunnelse: string
}

type Permisjonssøknadssak = {
  barnIdent: string
  barnNavn: string
  status: string
  merknad?: string
}

//avhengig av versjon av punkt, så kan det hente datepicker med range returnerer en array med datoer og ikke
//en kommasparert string. håndterer begge deler her for sikkerhets skyld
function parsePeriod(period: string | Array<string>) {
  if(typeof period === 'string') {
    return period.split(',')
  }
  return period
}

export async function submitPermisjonssøknad(permisjon: PermisjonssøknadFormData) {
  const [startDato, sluttDato] = parsePeriod(permisjon.periode)
  const request: PermisjonssøknadRequest = {
    barnIdent: permisjon.barnIdent,
    plasseringId: permisjon.plasseringId.toString(),
    startDato: startDato,
    sluttDato: sluttDato,
    begrunnelse: permisjon.begrunnelse,
  }
  return fetch(`${config.apiUrl}/api/barnehageplass/permisjon`, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(request)
  })
  .then(async res => {
    if (!res.ok) {
      throw new Error(`Kunne ikke sende inn permisjonssøknad: ${res.status} ${res.statusText}`)
    }
    return res
  })
}

export async function getPermisjonssøknadssak(id: string) {

  return fetch(`${config.apiUrl}/api/barnehageplass/permisjon/${id}`)
  .then(async res => {
    if (!res.ok) {
      throw new Error(`Kunne ikke hente permisjonssøknadssak: ${res.status} ${res.statusText}`)
    }
    return res
  }).then(r => r.json() as Promise<Permisjonssøknadssak>)

}

export const usePermisjonssøknadssak = useAsync(getPermisjonssøknadssak, false)